<circ-loader *ngIf="loading"></circ-loader>
<circulation-dialog
  [title]="'task.nodocument.dialog.title'"
  [content]="'task.nodocument.dialog.content'"
  [(opened)]="addDocumentsDialogOpened"
  (dialogClosed)="onAddDocumentsDialogClosed($event)"
  ></circulation-dialog>
<ng-container *ngIf="!loading">
  <h3>{{ 'step_forInformation_new_name' | i18n }}</h3>
  <h4>{{ title }}</h4>
  <p class="comment">{{ comment }}</p>
  <form class="k-form" [formGroup]="form">
    <fieldset class="k-form-fieldset">
      <kendo-formfield showHint="initial" showErrors="initial">
        <kendo-label [for]="workComment" [text]=" 'step_work_label_comment' | i18n "></kendo-label>
        <textarea kendoTextArea formControlName="workComment" #workComment required></textarea>
        <kendo-formhint>{{ 'step_work_formhint_comment' | i18n }}</kendo-formhint>
        <kendo-formerror>
        </kendo-formerror>
      </kendo-formfield>
      <div class="k-form-buttons">
        <ece-btn-primary [disabled]="disabled" (click)="confirm()" [text]=" 'step_forInformation_work_confirm' | i18n"></ece-btn-primary>
      </div>
    </fieldset>
  </form>
</ng-container>
